export const helperMethod = (something: any): string => `this is something: ${something}`;
